import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import Accordion from "/react4xp/components/shared/Accordion/Accordion";
import type { BaseContentPartProps } from "./BaseContent.d";
import type { ButtonProps } from "../Button/Button.d";

class ButtonPart extends React.Component<ButtonProps> {
  handleClick = () => {
    const external = !!this.props.url?.match(/^https?:/);
    if (external) {
      window.open(this.props.url, "_blank");
    } else {
      window.location.href = this.props.url;
    }
  };

  render() {
    return (
      <button
        onClick={this.handleClick}
        className={`btn ${this.props.backgroundColor} ${this.props.margin}`}
      >
        {this.props.title}
      </button>
    );
  }
}

export const BaseContentPart = (props: ComponentProps<PartData>) => {
  const { articleBlocks } = (props.data as BaseContentPartProps) ?? {};

  if (!articleBlocks?.length) {
    return null;
  }

  return (
    <>
      {articleBlocks &&
        articleBlocks.map((articleBlock, index) => (
          <React.Fragment key={index}>
            {articleBlock?.htmlArea?.content && (
              <div
                className="article-body"
                dangerouslySetInnerHTML={{
                  __html: articleBlock.htmlArea.content,
                }}
              ></div>
            )}

            {articleBlock?.factBox && (
              <div
                className={`${articleBlock.factBox.container} ${articleBlock.factBox.margin}`}
              >
                <div
                  className={`factbox  ${articleBlock.factBox.backgroundColor}`}
                  dangerouslySetInnerHTML={{
                    __html: articleBlock.factBox.content,
                  }}
                ></div>
              </div>
            )}

            {articleBlock?.accordion && (
              <Accordion accordionBlocks={articleBlock.accordion} />
            )}

            {articleBlock?.button && <ButtonPart {...articleBlock.button} />}
          </React.Fragment>
        ))}
    </>
  );
};

export default BaseContentPart;
